import Link from "next/link";
import {ComponentProps} from "react";

export default function InlineLink({className = "", ...props}: ComponentProps<typeof Link>) {
    return <Link className={`underline text-rm-blue ${className}`.trim()} {...props} />;
}
